module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "purple",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Lorem")]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.lorem))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "indigo",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.lorem.slice(0, 70)))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((2), function(n) {
    return _c('v-flex', {
      key: n,
      attrs: {
        "d-flex": "",
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "color": "red lighten-2",
        "dark": ""
      }
    }, [_c('v-card-text', [_vm._v(_vm._s(_vm.lorem.slice(0, 40)))])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": "",
      "child-flex": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "green lighten-2",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.lorem.slice(0, 90)))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "blue lighten-2",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.lorem.slice(0, 100)))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b60c4826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signup.vue
// module id = 54
// module chunks = 1